export default function ButtonShareWsp({text = '', url = '', children}) {
    const encodedText = encodeURIComponent(text);
    const encodedUrl = encodeURIComponent(url);
    return (
        <a
            href={`https://wa.me/?text=${encodedText}%20${encodedUrl}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            {children}
        </a>
    );
}